import React from 'react';
import { format } from 'date-fns';

export default function ProposalFooter({ proposal }) {
  // Get created by name - prefer created_by_name, fallback to created_by only if it's a real name
  const getCreatedByName = () => {
    if (proposal.created_by_name) return proposal.created_by_name;
    if (proposal.created_by && !proposal.created_by.includes('-')) {
      return proposal.created_by;
    }
    return '';
  };
  const creatorName = getCreatedByName();
  
  // Format the created date
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      return format(new Date(dateStr), 'MMM d, yyyy');
    } catch {
      return '';
    }
  };
  const createdDate = formatDate(proposal.created_at);

  return (
    <div className="px-6 pb-4 pt-2">
      <div className="border-t border-slate-200 pt-4">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 mb-3">Authorization</p>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border-b border-slate-400 h-6 mb-1" />
            <p className="text-[10px] text-slate-500">Client Signature & Date</p>
          </div>
          <div>
            {/* CLL Representative signature - signature-style font for name, normal for date */}
            <div className="border-b border-slate-400 h-8 mb-1 flex items-end justify-between px-1">
              {creatorName && (
                <>
                  <span 
                    className="text-slate-700 text-lg pb-0.5" 
                    style={{ fontFamily: "'Brush Script MT', 'Segoe Script', 'Bradley Hand', cursive", fontStyle: 'italic' }}
                  >
                    {creatorName}
                  </span>
                  <span className="text-[10px] text-slate-500 pb-1">{createdDate}</span>
                </>
              )}
            </div>
            <p className="text-[10px] text-slate-500">CLL Representative & Date</p>
          </div>
        </div>
      </div>
      
      {/* Compact footer bar */}
      <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between text-[10px] text-slate-400">
        <span>Center Line Locating, LLC · Charlotte, NC · (704) 315-5820</span>
        <span>Proposal #{proposal.proposal_number || proposal.id}</span>
      </div>
    </div>
  );
}
